import GrmMediaStreamTrackGenerator from "@/lib/gooroomee/track-generator/GrmMediaStreamTrackGenerator";
import Worker from 'worker-loader!./GrmMediaStreamTrackGeneratorWorker.runner'
import GrmWorkerUtils from "@/lib/gooroomee/worker/grm-worker-utils";
import {ImageUtils} from "@/lib/gooroomee/image-process/ImageUtils";


export default class GrmMediaStreamTrackGeneratorWorker extends GrmMediaStreamTrackGenerator {
    worker;
    workerProxy;

    async init() {
        const options = this._options;
        let {stream, track, fps} = options;
        if(stream){
            track = stream.getVideoTracks()[0];
        }else if(track){
            stream = new MediaStream([track]);
        }
        Object.assign(this._props, {
            stream,
            track
        });

        const canvas = document.createElement('canvas');
        Object.assign(this._props, {
            canvas,
        });

        const {width, height, frameRate, facingMode} = track.getSettings()
        this.resizeCanvas(width, height);
        this._props.fps = fps || frameRate || 30;
        this._props.facingMode = facingMode;

        const workerCanvas = canvas.transferControlToOffscreen();
        Object.assign(this._props, {
            workerCanvas
        });

        const params = this._getMediaStreamTrackProcessor();
        params.canvas = workerCanvas;

        // create worker
        this.worker = new Worker();
        // worker 로 보낼 methods 를 정의.
        this.workerProxy = await GrmWorkerUtils.createWorkerProxy({
            async init () {},
            async pause () {},
            async resume () {},
            async requestVideoFrameRender () {},
            async resize () {},
            async resizeCanvas () {},
            async changeFPS () {},
            async setPipeOptions () {},
            async setBlur () {},
            async setMirror () {},
            async setFaceDrawType () {},
            async changeReadableStream () {},
            // async pipeThrough () {},
            // async setFaceImage () {},
        }, this.worker);
        Object.assign(this, this.workerProxy);

        [
            'destroy',
            'setFaceImage', 'pipeThrough'].forEach(m => {
            this.workerProxy.addProxyMethod(m);
        });

        await this.workerProxy.init(params)
    }

    async destroy () {
        await super.destroy();
        await this.workerProxy.destroy();
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                try{
                    this.worker.terminate();
                }finally{
                    resolve()
                }
            }, 10)
        });
    }

    async _createFaceImage (img, size) {
        if(typeof img === 'string'){
            img = await (async () => {
                return new Promise((resolve, reject) => {
                    const image = new Image();
                    image.onload = () => resolve(image);
                    image.onerror = reject;
                    image.src = img;
                });
            })();
        }

        // resize
        (() => {
            size = size || 300;
            let {width, height} = ImageUtils.getSize(img);
            if(width === size) return;

            let ratio = size / width;
            const cvs = new OffscreenCanvas(width*ratio, height*ratio)
            const ctx = cvs.getContext('2d');
            ctx.drawImage(img, 0, 0, ctx.canvas.width, ctx.canvas.height);
            img = cvs;
        })();

        if(
            img instanceof ImageBitmap === false
            // || img instanceof HTMLCanvasElement
            // || img instanceof OffscreenCanvas
            // || img instanceof VideoFrame
            // || img instanceof HTMLVideoElement
        ){
            img = await createImageBitmap(img);
        }
        return img
    }
    async pipeThrough (name, options) {
        if(options?.faceImage){
            options.faceImage = await this._createFaceImage(options?.faceImage);
        }
        return this.workerProxy.pipeThrough(name, options);
    }

    async setFaceImage (image, size) {
        image = this._createFaceImage(image, size);
        return this.workerProxy.setFaceImage({image});
    }

    async replaceVideoMediaStreamTrack (track) {
        await super.replaceVideoMediaStreamTrack(track, false);
        const params = this._getMediaStreamTrackProcessor();
        return this.workerProxy.changeReadableStream(params);

    }
}